import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '@optsolservices/ngx-spinner';


@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
    constructor(
        private spinnerService: SpinnerService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.url.includes('alive_pulse')) {
            this.spinnerService.show();
        }
        return next.handle(request).pipe(
            finalize(() => {
                if (!request.url.includes('alive_pulse')) {
                    this.spinnerService.hide();
                }
            })
        );
    }
}
